<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="products"
          :search="search"
        >
          <template #top>
            <v-row>
              <v-col cols="12" md="10">
                <v-text-field v-model="search" label="Suche">
                  <v-icon slot="append">
                    mdi-magnify
                  </v-icon>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="d-flex justify-end mt-3">
                <v-btn color="primary" @click="createProductPrompt = true">
                  Hinzufügen
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <template #[`item.actions`]="{ item }">
            <Inertia-Link :href="route('product.edit', item.id)">
              <v-icon small>
                mdi-pencil
              </v-icon>
            </Inertia-Link>

            <v-icon @click="deletePrompt(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="createProductPrompt" max-width="1000">
      <ProductCreate
        :taxes="taxes"
        :product-types="productTypes"
        @updated="updated"
      />
    </v-dialog>
    <v-dialog v-model="deleteProductPrompt" max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          Sind Sie sicher dass dieses Item entfernt werden soll?
        </v-card-title>

        <v-card-text> Item: {{ selectedItem.productName }} </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="green darken-1"
            text
            @click="deleteProductPrompt = false"
          >
            Disagree
          </v-btn>

          <v-btn color="red darken-1" text @click="softDelete()">
            Agree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
import ProductCreate from '@/Components/Admin/Product/Create'

export default {
   name: 'ProductIndex',
   metaInfo () {
      return {
         title: this.title ? this.title : 'Produkt Übersicht',
      }
   },
   components: {
      ProductCreate,
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      taxes: {
         type: Array,
         required: true,
      },
      productTypes: {
         type: Array,
         required: true,
      },
      products: {
         type: Array,
         required: true,
      },
   },
   data () {
      return {
         headers: [
            { text: 'Typ', value: 'productType' },
            { text: 'Name', value: 'productName' },
            { text: 'Prozent', value: 'percent' },
            { text: 'Erstellt am', value: 'created_at' },
            { text: 'Aktionen', value: 'actions', sortable: false },
         ],
         search: null,
         selectedItem: {
            id: null,
            productName: '',
         },
         deleteProductPrompt: false,
         createProductPrompt: false,
      }
   },
   methods: {
      deletePrompt (item) {
         this.selectedItem = item
         this.deleteProductPrompt = true
      },
      softDelete () {
         this.$inertia
            .patch(this.route('product.soft_destroy', this.selectedItem.id))
            .then((response) => (this.deleteProductPrompt = false))
      },
      updated () {
         this.createProductPrompt = false
      },
   },
}
</script>

<style></style>
